import store from '../store'

export function getSkillTitle(skillId) {
  const skillTitle = store.state.skills[skillId].localizedTitle.lt;
  return skillTitle;
}